<header class="register-dialog__header">
  <span>{{ 'Regístrate' | translate }}</span>
  <button type="button" class="register-dialog__close-btn" (click)="dismissDialog()">&#x2715;</button>
</header>

<div class="register-dialog__content">
  <form class="register-dialog__form" [formGroup]="registerForm" (ngSubmit)="register()" #registerFormRef="ngForm">
    <p>{{ '¡Te damos la bienvenida a Cicerone!' | translate }}</p>

    <div class="form-group-register">
      <label class="labels">
        <span [ngClass]="{ 'error-color': registerFormRef.submitted && f.email.invalid }">{{ 'Correo electrónico' | translate }}</span> *
      </label>
      <div class="divInputStyle">
        <input autocomplete="off" type="text" (focusin)="focusin($event)" formControlName="email" class="inputs-pdf" />
      </div>
      @if (registerFormRef.submitted && f.email.invalid && (f.email.dirty || f.email.touched)) {
        <div class="error-wrapper">
          @if (f.email.errors?.['required']) {
            <div>{{ 'Email es requerido' | translate }}</div>
          }
          @if (f.email.errors?.['email']) {
            <div>{{ 'Email no válido' | translate }}</div>
          }
        </div>
      }
    </div>

    <div class="form-group-register">
      <label class="labels">
        <span>{{ 'Contraseña' | translate }}</span> *
      </label>
      <div class="divInputStyle">
        <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" formControlName="password" class="inputs-pdf" />
        <button type="button" class="show-button" (click)="showPassword()">
          {{ passwordType === 'password' ? '👁' : '👁‍🗨' }}
        </button>
      </div>
      @if (registerFormRef.submitted && f.password.invalid && (f.password.dirty || f.password.touched)) {
        <div class="error-wrapper">
          @if (f.password.errors?.['required']) {
            <div>{{ 'Contraseña es requerida' | translate }}</div>
          }
          @if (f.password.errors?.['minlength']) {
            <div>{{ 'Contraseña debe tener al menos 6 caracteres' | translate }}</div>
          }
        </div>
      }
    </div>

    <div class="form-group-register">
      <label class="labels">
        <span>{{ 'Confirma Contraseña' | translate }}</span> *
      </label>
      <div class="divInputStyle">
        <input autocomplete="off" [type]="passwordType" (focusin)="focusin($event)" formControlName="confirmPassword" class="inputs-pdf" />
        <button type="button" class="show-button" (click)="showPassword()">
          {{ passwordType === 'password' ? '👁' : '👁‍🗨' }}
        </button>
      </div>
      @if (registerFormRef.submitted && registerForm.hasError('notSame') && (registerForm.get('confirmPassword')?.dirty || registerForm.get('confirmPassword')?.touched)) {
        <div class="error-wrapper">
          {{ 'Las contraseñas no coinciden' | translate }}
        </div>
      }
    </div>

    <div class="accept-terms">
      <input formControlName="checkBox" type="checkbox" name="check" />
      <span [ngStyle]="{ color: registerFormRef.submitted && !checkConditions ? 'red' : '#000' }">
        {{ 'He leído y acepto los términos y condiciones de uso' | translate }}
      </span>
    </div>

    <button type="submit" [disabled]="registerFormRef.submitted && registerForm.invalid" class="submit-button">{{ 'Registrar' | translate }}</button>

    <app-social-login-buttons [withDivider]="true" [termsAccepted]="checkConditions" intent="register"></app-social-login-buttons>
  </form>
</div>
